import { useEffect, useState, useRef } from "react";
import { ArrowRight } from "lucide-react";

import { ProgramData } from "../../components/Programs/ProgramData";
import ProgramCard from "../../components/Programs/ProgramCard";
import { baseURL } from "@/utility/api";
import axios from "axios";

const ProgramPage = () => {
  const [isVisible, setIsVisible] = useState(false);
  const cardsRef = useRef(null);
  const [data, setData] = useState([]);

  useEffect(() => {
    setIsVisible(true);

    async function fetchData() {
      const response = await axios.get(`${baseURL}/cohort/get-all-details`);
      setData(response.data);
    }
    fetchData();
  }, []);

  // console.log("details", data);

  const scrollToCards = () => {
    if (cardsRef.current) {
      // Changed from "center" to "start" to scroll to the top of the cards section
      cardsRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className="min-h-screen bg-[linear-gradient(to_bottom,rgba(0,0,0,0)_0%,rgba(0,0,0,0.8)_100%)] py-24 px-4 sm:px-6 lg:px-8">
      {/* Header */}
      <div className="max-w-7xl mx-auto mb-16">
        <h1 className="text-3xl md:text-5xl max-w-full font-bold text-white mb-4 tracking-tight">
          Accelerate Your Career With Our{" "}
          <span className="text-[#a78bfa]">Premium Programs</span>
        </h1>
        <p className="text-md md:text-xl text-gray-300 max-w-full leading-relaxed mb-8">
          Learn proven strategies to secure off-campus internships with ease.
          From crafting impactful cold emails to building a standout resume,
          these programs give you actionable tips to land opportunities that
          others miss. Affordable, practical, and designed for students who want
          to stand out.
        </p>
      </div>

      {/* Cards Container */}
      <div className="max-w-7xl mx-auto" ref={cardsRef}>
        <div
          className={`grid md:grid-cols-2 gap-8 transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          } ${
            ProgramData.length % 2 !== 0
              ? "md:[&>*:last-child]:col-start-1 md:[&>*:last-child]:col-end-3 md:[&>*:last-child]:justify-self-center md:[&>*:last-child]:w-[calc(50%-1rem)]"
              : ""
          }`}
        >
          {ProgramData.map((cohort, index) => (
            <ProgramCard
              key={cohort.id}
              cohort={cohort}
              data={data?.find((small) => small.id === cohort.id)}
            />
          ))}
        </div>
      </div>

      {/* FAQ Section */}
      {/* <div className="max-w-4xl mx-auto mt-24 text-center">
        <h2 className="text-3xl font-bold text-white mb-4">Have questions?</h2>
        <p className="text-gray-300 mb-6">
          Learn more about our programs, application process, and success
          stories.
        </p>
        <button className="px-6 py-3 bg-transparent border border-[#a78bfa] text-[#a78bfa] hover:bg-[#a78bfa]/10 rounded-xl transition-colors duration-300">
          View Frequently Asked Questions
        </button>
      </div> */}

      {/* Footer Links */}
      {/* <div className="max-w-4xl mx-auto mt-24 text-center border-t border-gray-800 pt-8">
        <div className="flex justify-center space-x-8">
          <a
            href="#"
            className="text-gray-400 hover:text-[#a78bfa] transition-colors"
          >
            Privacy Policy
          </a>
          <a
            href="#"
            className="text-gray-400 hover:text-[#a78bfa] transition-colors"
          >
            Terms and Conditions
          </a>
          <a
            href="#"
            className="text-gray-400 hover:text-[#a78bfa] transition-colors"
          >
            Cancellation Policy
          </a>
        </div>
      </div> */}
    </div>
  );
};

export default ProgramPage;
